module.exports = __webpack_public_path__ + "assets/img/jackpot.df33dc49.png";